import { render } from "./Table.vue?vue&type=template&id=16aad9b8&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=16aad9b8&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16aad9b8"]])

export default __exports__